module.exports = __webpack_public_path__ + "static/media/20_l_holst_0.42_46.85.84f8e75f.png";